import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, { Dispatch, SetStateAction, useState } from "react";

function AutocompleteDropdown({
  id = "autocomplete",
  style,
  data,
  isLoading,
  setSearchValue,
  labelTag,
  placeholder = "Cauta",
  value,
  setSelectedItems,
}: {
  id: string;
  style?: React.CSSProperties;
  data: any[];
  isLoading?: boolean;
  setSearchValue?: Dispatch<SetStateAction<string>>;
  labelTag: string;
  placeholder?: string;
  value?: any[];
  setSelectedItems: Dispatch<SetStateAction<any[]>>;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Autocomplete
      id={id}
      style={{ ...style, marginTop: 7 }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      value={value}
      onInputChange={(event, value) => setSearchValue && setSearchValue(value)}
      onChange={(event, value) => {
        setSelectedItems(value);
      }}
      isOptionEqualToValue={(option, value) =>
        option[labelTag] === value[labelTag]
      }
      getOptionLabel={(option) => option[labelTag]}
      options={data}
      loading={isLoading}
      multiple={true}
      renderInput={(params) => (
        <TextField
          {...params}
          label={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}

export default AutocompleteDropdown;
